module.exports = __webpack_public_path__ + "static/media/bg-common73f6635850035c644a72d249ba5f86e0.webp";